export default __webpack_public_path__ + "static/media/file.abd559e3.svg";